// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "content-1NEbc";
var _4 = "buttons-1VolH";
var _5 = "title-3OzyL";
var _6 = "icon-1FsDM";
var _7 = "cancelButton-33X2o";
var _8 = "button-3VzpL";
export { _1 as "__esModule", _2 as "mobile", _3 as "content", _4 as "buttons", _5 as "title", _6 as "icon", _7 as "cancelButton", _8 as "button" }
export default { "__esModule": _1, "mobile": _2, "content": _3, "buttons": _4, "title": _5, "icon": _6, "cancelButton": _7, "button": _8 }
